import { DropdownButton } from "@biteship/atom";
import { useState } from "react";
import { COURIER_TYPES } from "@constants/courier";

export default function CourierType(props) {
  const [buttonTitle, setButtonTitle] = useState("Pilih Tipe Kurir");
  const dropdownOptions = () => {
    return COURIER_TYPES.map((i) => ({
      title: i.title,
      onClick: (e) => {
        setButtonTitle(i.title);
        props.onSelect(i.value);
      },
    }));
  };
  return (
    <DropdownButton
      title={
        <div
          className={`${buttonTitle === "Pilih Tipe Kurir" ? "text-gray-700" : "text-gray-900"}`}
        >
          {buttonTitle}
        </div>
      }
      actions={[dropdownOptions()]}
      buttonClassName="items-center border-gray-700"
      menuClassName="w-full max-h-56"
      className="w-full"
    />
  );
}
